import {
  Checkbox,
  FormControl,
  Input,
  ListItemText,
  MenuItem,
  Select,
  Tooltip
} from '@material-ui/core'
import { Theme } from '@material-ui/core'
import { SelectProps } from '@material-ui/core/Select'
import { StyleRulesCallback, withStyles } from '@material-ui/core/styles'
import React from 'react'
import { diffArray } from '../helpers'

const styles = (theme: Theme) => ({
  formControl: {
    fontFamily: 'Omnes',
    margin: theme.spacing.unit,
    width: '100%'
  },
  root: {
    background: '#F1F2F2',
    borderRadius: '3px',
    display: 'flex',
    flexWrap: 'wrap',
    fontFamily: 'Omnes',
    height: '48px'
  }
})

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
}

export interface IBB8Select {
  id: string
  classes: any
  handleChange: any
  items: Array<{ value: string | number; key: string }>
}

class BB8Select extends React.Component<IBB8Select> {
  public state: { selected: any[] } = {
    selected: []
  }

  // @TODO: For the future, refactor this method in chunks
  public handleChange = (event: any) => {
    const { selected } = this.state
    // tslint:disable-next-line:one-variable-per-declaration
    let target, unSelection, index
    if (selected.length > event.target.value.length) {
      unSelection = diffArray(selected, event.target.value)
      target = unSelection[0]
    } else {
      target = event.target.value[event.target.value.length - 1]
    }
    index = selected.indexOf(target)

    if (target === 'All' || target === 'all') {
      if (index > -1) {
        const options = this.props.items
          .filter(({ value }) => value !== 'All' && value !== 'all')
          .map(({ value }) => value)
        this.setState({ selected: options }, this.props.handleChange(options))
      } else {
        this.setState({ selected: [target] }, this.props.handleChange([target]))
      }
      return
    }

    if (index > -1) {
      selected.splice(index, 1)
      this.setState({ selected }, this.props.handleChange(selected))
    } else {
      const options = selected.filter(item => item !== 'All' && item !== 'all')
      const newSelection = options.concat(target)
      this.setState({ selected: newSelection }, this.props.handleChange(newSelection))
    }
  }

  public componentWillMount() {
    this.setState({
      selected: this.state.selected.concat(this.props.items[0].value)
    })
  }

  public render() {
    const { id, classes, items } = this.props
    const { selected } = this.state

    return (
      <div className={classes.root}>
        <FormControl className={classes.formControl}>
          <Tooltip title={this.renderValue(selected)} placement="top">
            <Select
              multiple={true}
              value={selected}
              onChange={this.handleChange}
              input={<Input style={{ fontFamily: 'Omnes' }} id={id} />}
              renderValue={this.renderValue}
              MenuProps={MenuProps}
              disableUnderline={true}
            >
              {items.map(item => (
                <MenuItem
                  id={item.key.toLowerCase().replace(' ', '-')}
                  key={item.key}
                  value={item.value}
                >
                  <Checkbox checked={this.state.selected.indexOf(item.value) > -1} />
                  <ListItemText
                    style={{ fontFamily: 'Omnes' }}
                    disableTypography={true}
                    primary={item.key}
                  />
                </MenuItem>
              ))}
            </Select>
          </Tooltip>
        </FormControl>
      </div>
    )
  }

  public renderValue = (selected: SelectProps['value']) => {
    if (!selected) {
      return
    }
    if (typeof selected === 'string' || typeof selected === 'number') {
      return selected.toString()
    }
    if (Array.isArray(selected)) {
      if (selected[0] && selected[0].toString().toLowerCase() === 'all') {
        return ['Show All'].join(', ')
      }
      return selected.join(', ')
    }
    return
  }
}

export default withStyles(styles as StyleRulesCallback<'root' | 'formControl'>, {
  withTheme: true
})(BB8Select)
